export default "/assets/images/mila-feed-04.mp4?86b73cd31860bc6825afb66687596a0d";